import React from 'react';
import { Box, Typography } from '@mui/material';
import { get } from 'lodash';
import { canDistinguish } from '@ivymobi/orbit-core/util/fileType';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import * as styles from './qrcode.module.scss';

export default function ShareContent (props) {
  const { qrTitle, url, showEmail, user, onSubmit } = props;

  const onCloseClick = () => {

  }

  const onChange = () => {

  }

  const sendEmail = () => {

  }

  const showEmailInput = () => {

  }

  return (
    <div className={classnames(styles.mask)}>
    {
      showEmail ? 
      (
        <div className={styles.container}>
          <div className={styles.titleContainer} style={{borderBottom: 0, top: 20}}>
            <span className={styles.close}>
            </span>
            <p className={styles.title}></p>
            <span className={styles.close} onClick={onCloseClick}>
              <i className={classnames('iconfont')} >&#xe64e;</i>
            </span>
          </div>
          <p className={styles.title} style={{marginTop: 20, fontSize: 25}}>发送至邮箱</p>
          <div className={styles.emailInput}>
            <input type='text' name='email' defaultValue={this.email && this.email.length > 0 && this.email} className={styles.url} placeholder='请输入邮箱地址' onChange={onChange} />
            <div className={styles.emailContainer}>
              <button type="button" disabled={!this.state.buttonEnable} onClick={sendEmail} className={classnames(styles.email, !this.state.buttonEnable ? styles.disable : null)}>发送</button>
            </div>
          </div>
        </div>
      )
      :
      (
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <span className={styles.close}>
          </span>
          <p className={styles.title}>{qrTitle}</p>
          <span className={styles.close} onClick={onCloseClick}>
            <i className={classnames('iconfont')} >&#xe64e;</i>
          </span>
        </div>
        {/* <div className={classnames('HpQrcode', styles.qrcode)}>
          <QRCode value={url}  />
        </div> */}
        <div className={styles.noWeChat}>
          <p>使用微信或 QQ 扫描分享或复制链接访问</p>
          <input className={styles.url} readOnly="true" type="text" name="name" value={url} />
          <div className={styles.downloadContainer} onClick={this.download}>
            <a className={styles.download} ref={(ref) => this.downloadRef = ref}>
              <i className={classnames('iconfont', styles.icon)}>&#xe66c;</i>
              <span>下载二维码</span>
            </a>
          </div>
          {
            !user && (
            <div className={styles.downloadContainer} onClick={showEmailInput}>
              <a className={styles.email} >
                <span>发送到我的邮箱</span>
              </a>
            </div>
            )
          }
        </div>
      </div>
      )
    }
  </div>
  )
}
